import { Link, NavLink, Outlet } from "react-router-dom";
import "./SiteLayout.css";

const footerLinks = [
  { label: "Terms of Service", href: "/terms" },
  { label: "Privacy Policy", href: "/policy" },
  { label: "Imprint (Legal Notice)", href: "/imprint" },
];

function SiteLayout() {
  const getNavLinkClassName = ({ isActive }) =>
    `site-layout__link${isActive ? " is-active" : ""}`;

  return (
    <div className="site-layout">
      <header className="site-layout__header">
        <nav className="site-layout__nav" aria-label="Main navigation">
          <NavLink to="/" end className={getNavLinkClassName}>
            Home
          </NavLink>
          <NavLink to="/getItApp" className={getNavLinkClassName}>
            Get It?
          </NavLink>
          <NavLink to="/about" className={getNavLinkClassName}>
            About
          </NavLink>
          <NavLink to="/contact" className={getNavLinkClassName}>
            Contact
          </NavLink>
        </nav>
      </header>
      <main className="site-layout__main">
        <Outlet />
      </main>
      <footer className="site-layout__footer">
        <p className="site-layout__footer-copyright">
          &copy; {new Date().getFullYear()} LarsHamburger. All rights reserved.
        </p>
        <nav className="site-layout__footer-links" aria-label="Legal links">
          {footerLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className="site-layout__footer-link"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </footer>
    </div>
  );
}

export default SiteLayout;
